import type { PostTemplateFunctionReq, DefaultQueryTemplateFunctionReqRes, TemplateFunctionRes } from 'types/templates';
import { heliosApi } from '.';
import { TAG_TYPES } from 'types/services';

export const heliosTemplateFunctionsService = heliosApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getTemplateFunctions: builder.query<TemplateFunctionRes[], { id: string; includeRelatedDetail?: boolean }>({
      query: ({ id, includeRelatedDetail }) => ({
        url: `TemplateFunctions/${id}`,
        method: 'GET',
        params: {
          ...(includeRelatedDetail && { includeRelatedDetail: true }),
        },
      }),
      providesTags: [{ type: TAG_TYPES.TEMPLATE_FUNCTIONS, id: 'LIST' }],
    }),

    getTemplateFunctionById: builder.query<TemplateFunctionRes, { id: string }>({
      query: ({ id }) => ({
        url: `TemplateFunctions/Function/${id}`,
        method: 'GET',
      }),
      providesTags: [{ type: TAG_TYPES.TEMPLATE_FUNCTIONS, id: 'DETAIL' }],
    }),

    createTemplateFunction: builder.mutation<DefaultQueryTemplateFunctionReqRes, PostTemplateFunctionReq>({
      query: (data) => ({
        url: 'TemplateFunctions',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: TAG_TYPES.TEMPLATE_FUNCTIONS, id: 'LIST' }],
    }),

    updateTemplateFunction: builder.mutation<DefaultQueryTemplateFunctionReqRes, DefaultQueryTemplateFunctionReqRes>({
      query: (data) => ({
        url: 'TemplateFunctions',
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: [
        { type: TAG_TYPES.TEMPLATE_FUNCTIONS, id: 'LIST' },
        { type: TAG_TYPES.TEMPLATE_FUNCTIONS, id: 'DETAIL' },
      ],
    }),

    removeTemplateFunction: builder.mutation<void, { ids: string[] }>({
      query: ({ ids }) => ({
        url: 'TemplateFunctions',
        method: 'DELETE',
        params: { ids },
      }),
      invalidatesTags: [{ type: TAG_TYPES.TEMPLATE_FUNCTIONS, id: 'LIST' }],
    }),
  }),
});
export const {
  useGetTemplateFunctionsQuery,
  useGetTemplateFunctionByIdQuery,
  useLazyGetTemplateFunctionByIdQuery,
  useCreateTemplateFunctionMutation,
  useUpdateTemplateFunctionMutation,
  useRemoveTemplateFunctionMutation,
} = heliosTemplateFunctionsService;
